import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { connectMerchant, disconnectMerchant, errorMessage, fetchConnection } from "../api";

/** Estado da aba Conexão: lojas vinculadas e saúde do polling.
 *  Recarrega sozinho a cada 30 s para o "aberta/fechada" não ficar velho. */
export default function useIfoodConnection() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState("");

  const reload = useCallback(async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      setData(await fetchConnection());
    } catch (e) {
      if (!silent) toast.error(errorMessage(e, "Não foi possível carregar a conexão com o iFood"));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
    const id = setInterval(() => reload(true), 30000);
    return () => clearInterval(id);
  }, [reload]);

  const connect = async (merchantId, label) => {
    setBusy("connect");
    try {
      const r = await connectMerchant(merchantId, label);
      toast.success(`Loja conectada: ${r.name || merchantId}`);
      await reload(true);
      return true;
    } catch (e) {
      toast.error(errorMessage(e, "Não foi possível conectar a loja"), { duration: 9000 });
      return false;
    } finally {
      setBusy("");
    }
  };

  const disconnect = async (merchantId) => {
    setBusy(`disconnect:${merchantId}`);
    try {
      await disconnectMerchant(merchantId);
      toast.success("Loja desconectada do Núcleo");
      await reload(true);
    } catch (e) {
      toast.error(errorMessage(e, "Não foi possível desconectar"));
    } finally {
      setBusy("");
    }
  };

  return { data, loading, busy, reload, connect, disconnect };
}
